import {
  BooleanInput,
  Create,
  Edit,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from 'react-admin';

const CityFormFields = () => (
  <>
    <TextInput source="name" fullWidth validate={(value) => (!value ? 'Name is required' : undefined)} />
    <TextInput source="slug" fullWidth helperText="Leave blank to auto-generate from name" />
    <ReferenceInput source="state_id" reference="states" label="State">
      <SelectInput optionText="name" validate={(value) => (!value ? 'State is required' : undefined)} />
    </ReferenceInput>
    <BooleanInput source="is_active" label="Active" defaultValue />
  </>
);

export function CityEdit() {
  return (
    <Edit>
      <SimpleForm>
        <CityFormFields />
      </SimpleForm>
    </Edit>
  );
}

export function CityCreate() {
  return (
    <Create redirect="list">
      <SimpleForm defaultValues={{ is_active: true }}>
        <CityFormFields />
      </SimpleForm>
    </Create>
  );
}
